import { DEFAULT_PARAMS, objectsRHandler } from '@/utils/objectsRHandler';

import { rHandler } from '@/plugins/RHandler';
import { apiService } from '@/services/APIService';

import Exchange from '../list/exchange/index';
import Event from '../list/event';

export const ExchangeManager = {
  get objects() {
    const path = 'exchanges';
    return objectsRHandler(path, Exchange);
  },
  get own() {
    const path = 'own-exchanges';
    return {
      ...objectsRHandler(path, Exchange),
      createTarget({ args = [], data, obs } = DEFAULT_PARAMS) {
        const [exchangeId] = args;
        return rHandler(
          apiService.post(`${path}/${exchangeId}`, data),
          (response) => ({
            response,
            item: new Exchange(response.data.data, path),
          }),
          (error) => ({ error }),
          obs,
        );
      },
      eventsToReview({ params } = DEFAULT_PARAMS) {
        return rHandler(
          apiService.get(`${path}/events-to-review`, params),
          (response) => ({
            response,
            items: response?.data?.data || [],
          }),
          (error) => ({ error }),
        );
      },
      eventStatistic({ args = [], params } = DEFAULT_PARAMS) {
        const [eventId] = args;
        return rHandler(
          apiService.get(`${path}/events/${eventId}/statistic`, params),
          (response) => ({
            response,
            item: response?.data?.data,
          }),
          (error) => ({ error }),
        );
      },
      eventOrganizers({ args = [], params } = DEFAULT_PARAMS) {
        const [eventId] = args;
        return rHandler(
          apiService.get(`${path}/events/${eventId}/organizers`, params),
          (response) => ({
            response,
            items: response?.data?.data || [],
          }),
          (error) => ({ error }),
        );
      },
      allOrganizers({ params } = DEFAULT_PARAMS) {
        return rHandler(
          apiService.get(`${path}/organizers`, params),
          (response) => ({
            response,
            items: response?.data?.data || [],
          }),
          (error) => ({ error }),
        );
      },
      organizers({ args = [], params } = DEFAULT_PARAMS) {
        const [exchangeId] = args;
        return rHandler(
          apiService.get(`${path}/${exchangeId}/organizers`, params),
          (response) => ({
            response,
            items: response?.data?.data || [],
          }),
          (error) => ({ error }),
        );
      },
      confirm({ args = [], data, obs } = DEFAULT_PARAMS) {
        const [exchangeId] = args;
        return rHandler(
          apiService.post(`${path}/${exchangeId}/confirm`, data),
          (response) => ({
            response,
            item: response?.data?.data,
          }),
          (error) => ({ error }),
          obs,
        );
      },
      reject({ args = [], data, obs } = DEFAULT_PARAMS) { // { reason? }
        const [exchangeId] = args;
        return rHandler(
          apiService.post(`${path}/${exchangeId}/reject`, data),
          (response) => ({
            response,
            item: response?.data?.data,
          }),
          (error) => ({ error }),
          obs,
        );
      },
      massReject({ data, obs } = DEFAULT_PARAMS) { // { exchange_ids, reason? }
        return rHandler(
          apiService.post(`${path}/mass-reject`, data),
          (response) => ({
            response,
            item: response?.data?.data,
          }),
          (error) => ({ error }),
          obs,
        );
      },
    };
  },
};
